<a (click)="goToCart()" class="navigation-cart">
  <div class="flex">
    <p class="cart-items-info">
      <span class="info-text">{{ "COMMON.CART" | translate }}: </span>
      <span>{{ cartItemsLength }}</span>
    </p>
    <div class="cart-ticket-line"></div>
  </div>

  <img src="img/icons/cart.svg" alt="Cart" class="cart-icon" />   
</a>